import React from 'react';
import { Plus, Minus, Trash2 } from 'lucide-react';

// Free-scan counts. Tapping a count opens the correction dialog; Remove sits apart from
// the +/- buttons (and is undoable) so it isn't hit by mistake. Below 768px the CSS
// turns each row into a card.
const FreeScanTable = ({ itemsArray, isCompact, incrementCount, decrementCount, removeItem, onEditCount, formatTime }) => {
  if (itemsArray.length === 0) return null;

  // Most recent scan on top. +/- don't touch lastScanned, so adjusting a count never
  // moves the row out from under your finger.
  const sorted = [...itemsArray].sort((a, b) => b.lastScanned - a.lastScanned);

  return (
    <div className="scanned-items-wrapper">
      <table className="scanned-items-table free-scan-table">
        <thead>
          <tr>
            <th>Barcode</th>
            <th>Count</th>
            <th>{isCompact ? 'Time' : 'Last Scanned'}</th>
            <th>Adjust</th>
            <th><span className="sr-only">Remove</span></th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((item, index) => (
            // The newest row's key includes its scan time, so it remounts and replays the
            // highlight on every scan - including a repeat scan of the same barcode.
            <tr
              key={index === 0 ? `${item.barcode}-${item.lastScanned.getTime()}` : item.barcode}
              className={index === 0 ? 'latest-scan' : ''}
            >
              <td className="barcode-cell">{item.barcode}</td>
              <td className="count-cell">
                <button
                  type="button"
                  className="st-count-btn"
                  onClick={() => onEditCount(item)}
                  aria-label={`Count ${item.count} for ${item.barcode}. Tap to correct`}
                >
                  {item.count}
                </button>
              </td>
              <td className="time-cell">{formatTime(item.lastScanned)}</td>
              <td className="actions-cell">
                <div className="count-controls">
                  <button
                    type="button"
                    className="count-button decrement"
                    onClick={() => decrementCount(item.barcode)}
                    aria-label={`Decrease count for ${item.barcode}`}
                  >
                    <Minus size={20} aria-hidden="true" />
                  </button>
                  <button
                    type="button"
                    className="count-button increment"
                    onClick={() => incrementCount(item.barcode)}
                    aria-label={`Increase count for ${item.barcode}`}
                  >
                    <Plus size={20} aria-hidden="true" />
                  </button>
                </div>
              </td>
              <td className="remove-cell">
                <button
                  type="button"
                  className="remove-button"
                  onClick={() => removeItem(item.barcode)}
                  aria-label={`Remove ${item.barcode}`}
                >
                  <Trash2 size={16} aria-hidden="true" /> Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FreeScanTable;
